import sharedConstants from "@lib/shared_constants";

export const channelDashboardData = "/channel_dashboard/:app_group_id/:channel_type" as const;

export const sendFrequencyBucketKeys = sharedConstants.PUSH_ANALYTICS_HUB.FREQUENCY_BUCKETS;

/**
 * Every cadence tier the push cadence endpoints report, ordered by how long the user waited before
 * the message. The `CadenceTier` type is derived from this array, so the two cannot drift apart.
 *
 * This is the order the cadence chart's x-axis uses. The API returns the tiers in this order too
 * (see `PUSH_CADENCE_TIERS` in channel_dashboard_stats_helper.rb, which must stay in step with
 * these exact strings), but the chart orders them itself rather than trusting the response's key
 * order.
 */
export const cadenceTiersInOrder = ["0-1 Day", "1 Week", "2 Weeks", "3 Weeks", "1 Month"] as const;
